/**
 * Applied to the element that is active descendant
 */ export const ACTIVEDESCENDANT_ATTRIBUTE = 'data-activedescendant';
/**
 * Applied to the active descendant when the user is navigating with keyboard
 */ export const ACTIVEDESCENDANT_FOCUSVISIBLE_ATTRIBUTE = 'data-activedescendant-focusvisible';
